export default __webpack_public_path__ + "static/media/digital_currency_deposit.0139b011.svg";